import React from 'react'
import { Trans } from '@lingui/macro'
import {  useSelector } from 'react-redux'
import { DotsVerticalIcon } from '@heroicons/react/outline'

import { getColor } from 'components/utils'
import { Alert } from 'components/UI/Alert/Alert'
import { IdTransferCashDesksState } from "model/dashboardTransferCashDesks/dTransferCashDesksReducer";
import { ButtonLink } from 'components/UI/ButtonLink/ButtonLink'

// Type
export type typeTableHeader = {
    variant?: string

}

// Header data component
export const TableHeader: React.FC<typeTableHeader> = () => {


    return (

        <>

            <th scope="col" className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">
                <Trans>Date</Trans>
            </th>

            <th scope="col" className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">
                <Trans>Cash Desk serial number</Trans>
            </th>

            <th scope="col" className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">
                <Trans>Status</Trans>
            </th>

            <th scope="col" className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">
                <Trans>To user</Trans>
            </th>

            <th scope="col" className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">
                <Trans>Who did it</Trans>
            </th>
            <th scope="col" className="w-1">
            </th>
        </>

    )
}

// Type
export type typeAction = {
    title: JSX.Element,
    disableSwitcher?: boolean,
    action: ( id: string ) => void,
}

export type typeTableBody = {
    variant?: string
    rowsActions?: typeAction[]
    setOpenPopupDetails: React.Dispatch<React.SetStateAction<boolean>>
}

// Body data component
export const TableBody: React.FC<typeTableBody> = ( { variant, rowsActions, setOpenPopupDetails } ) => {

    const color = getColor(variant)

    const tableData = useSelector(( state: { dTransferCashDesks: IdTransferCashDesksState } ) => state.dTransferCashDesks.data)

    // const onCellClickHandler = ( e: React.MouseEvent<HTMLTableDataCellElement, MouseEvent>, id: string ) => {
    //     dispatch(dTransferCashDesksSetDetailItemAC(id))
    //     setOpenPopupDetails(true)
    // }

    let component

    if (tableData.length) {
        component = tableData.map(( item, index ) => {


            const date = new Date(item.date!).toLocaleString() || ''


            return (
                <tr key={item.id}
                    className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} hover:bg-${color}-50`}>
                    <td className="px-4 py-3 whitespace-nowrap w-1/4 text-sm font-sm text-gray-500 cursor-pointer"
                       // onClick={( e ) => onCellClickHandler(e, item.id)}
                    >
                        <div className="flex flex-col">

                            <span className="text-gray-900 font-normal">{date.substring(0, 10) || ''}</span>
                            <span
                                className="text-gray-500 text-xs leading-4  font-normal">{date.substring(11) || ''}</span>
                        </div>

                    </td>

                    <td className="px-4 py-3 whitespace-wrap text-sm font-normal leading-5 text-gray-900 cursor-pointer"
                       // onClick={( e ) => onCellClickHandler(e, item.id)}
                    > {item.posSnNumber}
                    </td>


                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 cursor-pointer"
                      //  onClick={( e ) => onCellClickHandler(e, item.id)}
                    >
                        {item.status}
                    </td>

                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 cursor-pointer"
                        //  onClick={( e ) => onCellClickHandler(e, item.id)}
                    >
                        {item.to.name}
                    </td>


                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 cursor-pointer"
                        //  onClick={( e ) => onCellClickHandler(e, item.id)}
                    >
                        {item.whoDidIt.name}
                    </td>


                    <td className="whitespace-nowrap text-sm text-gray-500 pr-2">
                        <div className="relative flex">
                            {
                                rowsActions &&  <div className=" row-action-block">
                                    <DotsVerticalIcon className="row-action-list-open-button h-5 w-5 text-gray-900"/>
                                    <div className="row-action-list">
                                        <div className="flex gap-x-4">
                                            {rowsActions && rowsActions.map(( actionItem, ActionIndex ) =>
                                                                                <ButtonLink key={ActionIndex}
                                                                                            type={'button'}
                                                                                            label={actionItem.title}
                                                                                            onClick={() => actionItem.action(item.id)}/>)

                                            }

                                        </div>
                                    </div>
                                </div>
                            }

                        </div>
                    </td>
                </tr>
            )
        })
    } else {
        component = <tr>
            <td className="p-2" colSpan={6}>
                <Alert className="w-full" type={'info'}
                       title={<Trans>The TransferCashDesks list is empty. Click Add button to create transfer  or check filters.</Trans>}/>
            </td>
        </tr>
    }

    return (
        <>
            {component}
        </>
    )
}
